import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './styled';
import { color } from 'styles/pallete';
import { svg } from 'utils/imgList';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface CheckProps {
	isChecked?: boolean; // Indica se está marcado
	isError?: boolean; // Indica se há erro
	setIsChecked: any; // Função para alterar o estado de marcado
	id?: number; // ID do input
	onClick?: any; // Callback para clique
	text?: string; // Texto adicional
	widthCheck?: string; // Largura do checkbox
	widthSvgCheck?: number; // Largura do SVG
	colorCheck?: string; // Cor do checkbox
	ballRadius?: boolean; // Define se o checkbox tem bordas arredondadas
	disable?: boolean; // Define se o checkbox está desabilitado
	fontSize?: number; // Tamanho da fonte
}

const Check: React.FC<CheckProps> = ({
	isChecked = false,
	isError = false,
	setIsChecked,
	id = Math.random() * 1000,
	onClick = () => {},
	text = '',
	widthCheck = '20px',
	widthSvgCheck = 15,
	colorCheck = color.interface.green2,
	ballRadius = false,
	disable = false,
	fontSize = 1.2
}) => {
	const { t }: UseTranslationProps = useTranslation();

	return (
		<S.Container onClick={onClick}>
			<S.containerCheck
				onClick={(event) => {
					event.preventDefault(); // Previne ações padrão (se houver)
					if (!disable) {
						// Evita múltiplas chamadas alterando diretamente o estado
						setIsChecked((prevChecked: boolean) => !prevChecked);
					}
				}}
				isError={isError}
				widthCheck={widthCheck}
				borderColor={colorCheck}
				ballRadius={ballRadius}
				widthSvgCheck={widthSvgCheck}
			>
				<input type="checkbox" id={`${id}`} />
				<label
					htmlFor={`${id}`}
					style={isChecked ? { backgroundColor: colorCheck } : undefined}
				/>
				{isChecked ? <img src={svg.check} alt="check" /> : null}
			</S.containerCheck>
			{text !== '' && (
				<S.Box fontSize={fontSize}>
					<span>
						{text}
						{!isChecked && isError && (
							<span className="error-send">
								{t('optionsBannerIndividual.requiredField')}
							</span>
						)}
					</span>
				</S.Box>
			)}
		</S.Container>
	);
};

export default Check;
